import { render, staticRenderFns } from "./AnkleFeaturesTable.vue?vue&type=template&id=198a6fea&scoped=true&"
import script from "./AnkleFeaturesTable.vue?vue&type=script&lang=js&"
export * from "./AnkleFeaturesTable.vue?vue&type=script&lang=js&"
import style0 from "./AnkleFeaturesTable.vue?vue&type=style&index=0&id=198a6fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a6fea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
